import {Component, inject} from '@angular/core';
import {RDS_DIALOG_DATA, RdsButtonModule, RdsDialogModule} from "@rds/angular-components";
import {FormValidity} from "../detail-view-wrapper/detail-view-wrapper.component";

interface DialogData {
  state: FormValidity;
}
@Component({
  selector: 'app-procession-dialog',
  standalone: true,
  imports: [
    RdsDialogModule,
    RdsButtonModule
  ],
  templateUrl: './procession-dialog.component.html',
  styleUrl: './procession-dialog.component.scss'
})
export class ProcessionDialog {
  protected readonly state: FormValidity = (inject(RDS_DIALOG_DATA) as DialogData).state
}
